import { Box } from "@mui/material";
import { TableCellMultipleRow } from "components";
import ClickableAliasChips from "./ClickableAliasChips";

export const columnTableReport = ({ isDetail }) => [
  ...(isDetail
    ? [
        {
          name: "song_title",
          title: "Song",
          renderText: item => item || "-",
        },
        {
          name: "iswc",
          title: "ISWC",
          renderText: item => item || "-",
        },
      ]
    : [
        {
          name: "composer_name",
          title: "Composer/Author",
          renderText: item => item || "-",
        },
        {
          name: "composer_alias_name",
          title: "Alias Name",
          renderText: item => <ClickableAliasChips item={item} />,
        },
      ]),
  {
    name: "usage_on_dsp",
    title: "DSP",
    renderText: item => (
      <Box minWidth={100}>
        <TableCellMultipleRow
          list={item}
          itemKey="dsp_name"
          subItemChild="summaries"
        />
      </Box>
    ),
  },
  {
    name: "usage_on_dsp",
    title: "Traffic",
    headerAlign: "right",
    renderText: item => (
      <TableCellMultipleRow
        list={item}
        itemKey="summaries"
        subItemKey="traffic"
        type="number"
      />
    ),
  },
  {
    name: "usage_on_dsp",
    title: "Income",
    headerAlign: "right",
    renderText: item => (
      <TableCellMultipleRow
        list={item}
        itemKey="summaries"
        subItemKey="revenue"
        type="number"
        prefix="Rp"
      />
    ),
  },
  {
    name: "usage_on_dsp",
    title: "Market Share (Traffic)",
    renderText: item => (
      <TableCellMultipleRow
        list={item}
        itemKey="summaries"
        subItemKey="traffic_percentage"
      />
    ),
  },
  {
    name: "usage_on_dsp",
    title: "Market Share (Revenue)",
    renderText: item => (
      <TableCellMultipleRow
        list={item}
        itemKey="summaries"
        subItemKey="revenue_percentage"
      />
    ),
  },
  {
    name: "usage_on_dsp",
    title: "Product Type",
    renderText: item => (
      <TableCellMultipleRow
        list={item}
        itemKey="summaries"
        subItemKey="product_type"
      />
    ),
  },
  {
    name: "usage_on_dsp",
    title: "Composer Revenue",
    headerAlign: "right",
    renderText: item => (
      <TableCellMultipleRow
        list={item}
        itemKey="summaries"
        subItemKey="composer_revenue"
        type="number"
        prefix="Rp"
      />
    ),
  },
  {
    name: "usage_on_dsp",
    title: "Publisher Revenue",
    headerAlign: "right",
    renderText: item => (
      <TableCellMultipleRow
        list={item}
        itemKey="summaries"
        subItemKey="publisher_revenue"
        type="number"
        prefix="Rp"
      />
    ),
  },
  {
    name: "usage_on_dsp",
    title: "PPh",
    headerAlign: "right",
    renderText: item => (
      <TableCellMultipleRow
        list={item}
        itemKey="summaries"
        subItemKey="pph"
        type="number"
        suffix=" %"
      />
    ),
  },
  {
    name: "usage_on_dsp",
    title: "Grand Total",
    headerAlign: "right",
    renderText: item => (
      <TableCellMultipleRow
        list={item}
        itemKey="summaries"
        subItemKey="grand_total"
        type="number"
        prefix="Rp"
      />
    ),
  },
];
